exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.menu-group li {\r\n  position: relative;\r\n}\r\n#wrapper.toggled ul.menu-group li b.ti,\r\n#wrapper ul.menu-group li b.ti {\r\n  background: none;\r\n  color: #7f7f7f;\r\n  width: 10px;\r\n  height: 10px;\r\n  line-height: 10px;\r\n  position: absolute;\r\n  top: 23px;\r\n  right: 10px;\r\n  font-size: 14px;\r\n  transition: -webkit-transform 0.2s linear;\r\n  transition: transform 0.2s linear;\r\n  transition: transform 0.2s linear, -webkit-transform 0.2s linear;\r\n}\r\n@media (min-width: 320px) {\r\n  #wrapper.toggled ul.menu-group li b.ti {\r\n    display: none;\r\n  }\r\n  #wrapper ul.menu-group li b.ti {\r\n    display: block;\r\n  }\r\n}\r\n@media (min-width: 1025px) {\r\n  #wrapper.toggled ul.menu-group li b.ti {\r\n    display: block;\r\n  }\r\n  #wrapper ul.menu-group li b.ti {\r\n    display: none;\r\n  }\r\n}\r\n.open > .menu-item b {\r\n  -webkit-transform: rotate(90deg);\r\n  transform: rotate(90deg);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/navbar/navbar-eas.component.css
// module id = ../../../../../src/app/navbar/navbar-eas.component.css
// module chunks = main